import { ReactNode } from 'react'
import CustomLink from '../customLink'

interface LinkWrapperProps {
  children: ReactNode
  link?: string
}

const LinkWrapper: React.FC<LinkWrapperProps> = ({ children, link }) => {
  return link ? (
    <CustomLink href={link} prefetch={false}>
      {' '}
      {children}
    </CustomLink>
  ) : (
    <>{children}</>
  )
}

export default LinkWrapper
